// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11LK8","left":"styles_left__31ezR"};